/**
 * Kadima — Custom JavaScript
 * ===========================
 * 1. Bundle Offer (adicionar itens e atualizar tiers)
 * 2. Announcement Bar rotativo
 * 3. Mini-cart cross-sell recommendations
 *
 * Theme hooks disponíveis:
 * - document.addEventListener('variant:changed', fn)
 * - document.addEventListener('product:added', fn)
 * - document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
 * - document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: 1 } }))
 */

/* =================================================================
   1. BUNDLE OFFER — Adicionar itens complementares ao carrinho
   ================================================================= */
(function () {
  'use strict';

  // Adicionar item ao carrinho via AJAX
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-action="add-bundle-item"]');
    if (!btn) return;

    event.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    // Prevent double-click
    if (btn.disabled) return;
    btn.disabled = true;

    var originalText = btn.textContent;
    btn.textContent = 'Adicionando...';

    fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function () {
        btn.textContent = '✓ Adicionado';
        btn.classList.add('bundle-offer__add-btn--added');

        // Re-render NATIVO do mini-cart via evento do próprio tema Warehouse.
        // 'cart:refresh' chama o _rerender(): atualiza o contador do header,
        // re-renderiza o conteúdo do mini-cart preservando o nó cacheado pela
        // instância Cart (drawer continua abrindo sem F5) e NÃO abre o drawer.
        // detail.scrollToTop:false evita o salto pro topo (o window.scrollTo só
        // ocorre no _onProductAdded, que de propósito não disparamos aqui).
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { scrollToTop: false }
          })
        );

        // Atualiza tiers e cálculo de economia do widget
        updateBundleTiers();
      })
      .catch(function (err) {
        console.error('Kadima bundle: add error', err);
        btn.disabled = false;
        btn.textContent = originalText;
      });
  });

  // Atualizar highlight dos tiers baseado na quantidade de livros no carrinho
  function updateBundleTiers() {
    fetch(window.routes.cartUrl + '.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bookCount = 0;
        var bookTotal = 0;

        cart.items.forEach(function (item) {
          // Contar apenas livros físicos
          var ptype = (item.product_type || '').toLowerCase();
          if (ptype === 'físico' || ptype === 'livros' || ptype === 'livro') {
            bookCount += item.quantity;
            bookTotal += item.final_line_price;
          }
        });

        // Atualizar tiers visuais
        var tiers = document.querySelectorAll('.bundle-offer__tier');
        tiers.forEach(function (tier) {
          tier.classList.remove('bundle-offer__tier--active');
          var tierNum = parseInt(tier.getAttribute('data-tier'), 10);
          if (
            (tierNum === 1 && bookCount === 1) ||
            (tierNum === 2 && bookCount === 2) ||
            (tierNum === 3 && bookCount >= 3)
          ) {
            tier.classList.add('bundle-offer__tier--active');
          }
        });

        // Mostrar economia (se houver desconto automático configurado)
        var savingsEl = document.getElementById('bundle-savings');
        var savingsAmount = document.getElementById('bundle-savings-amount');
        if (savingsEl && savingsAmount && cart.total_discount > 0) {
          savingsEl.style.display = 'block';
          savingsAmount.textContent = formatMoney(cart.total_discount);
        }
      })
      .catch(function () { });
  }

  // Format money (centavos para reais)
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return 'R$ ' + amount;
  }

  // Inicializar tiers no carregamento da página
  if (document.querySelector('.bundle-offer')) {
    updateBundleTiers();
  }
})();


/* =================================================================
   2. ANNOUNCEMENT BAR ROTATIVO
   ================================================================= */
(function () {
  'use strict';

  var messages = [
    '📦 FRETE GRÁTIS para todo o Brasil',
    '💳 Parcele em até 12x no cartão',
    '🔒 Compra 100% segura — Dados protegidos',
    '⭐ +50.000 livros entregues em todo o Brasil'
  ];

  function initAnnouncementRotation() {
    // O tema Warehouse usa .announcement-bar__content ou texto direto
    var bar = document.querySelector('.announcement-bar__content');
    if (!bar) {
      // Tentar encontrar o elemento de texto da announcement bar
      bar = document.querySelector('.announcement-bar__text');
    }
    if (!bar) return;

    var index = 0;

    // Guardar mensagem original como primeiro item se não quiser sobrescrever
    // messages[0] já é a mensagem de frete grátis que é a atual

    setInterval(function () {
      index = (index + 1) % messages.length;
      bar.style.transition = 'opacity 0.3s ease';
      bar.style.opacity = '0';

      setTimeout(function () {
        bar.textContent = messages[index];
        bar.style.opacity = '1';
      }, 300);
    }, 4000);
  }

  // Executar após DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementRotation);
  } else {
    initAnnouncementRotation();
  }
})();


/* =================================================================
   3. MINI-CART CROSS-SELL RECOMMENDATIONS
   ================================================================= */
(function () {
  'use strict';

  function loadMiniCartRecommendations() {
    var container = document.getElementById('mini-cart-recommendations');
    if (!container) return;

    var productId = container.getAttribute('data-product-id');
    if (!productId) return;

    // Usar a Shopify Product Recommendations API
    var url =
      window.routes.productRecommendationsUrl +
      '?product_id=' + productId +
      '&limit=4&section_id=product-recommendations';

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('.product-item');

        if (!items.length) {
          container.style.display = 'none';
          return;
        }

        var output = '';
        var count = 0;

        items.forEach(function (item) {
          if (count >= 2) return; // Max 2 items no mini-cart

          var link = item.querySelector('a[href]');
          var img = item.querySelector('img');
          var title = item.querySelector('.product-item__title');
          var price = item.querySelector('.price');

          if (!link || !title) return;
          count++;

          var imgSrc = '';
          if (img) {
            imgSrc = img.getAttribute('data-src') || img.getAttribute('src') || '';
            // Garantir thumbnail pequeno
            if (imgSrc.includes('img_url')) {
              imgSrc = imgSrc.replace(/(\d+)x(\d*)/, '100x100');
            }
          }

          output += '<div class="mini-cart-rec" style="display:flex;align-items:center;gap:10px;padding:8px 0;border-bottom:1px solid var(--border-color)">';

          if (imgSrc) {
            output += '<img src="' + imgSrc + '" width="48" height="48" ' +
              'style="border-radius:4px;object-fit:cover;flex-shrink:0" ' +
              'alt="" loading="lazy">';
          }

          output += '<div style="flex:1;min-width:0">';
          output += '<p style="font-size:12px;font-weight:500;margin:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' +
            title.textContent.trim() + '</p>';

          if (price) {
            output += '<p style="font-size:12px;margin:2px 0 0;color:var(--text-color)">' +
              price.textContent.trim() + '</p>';
          }

          output += '</div>';
          output += '<a href="' + link.getAttribute('href') + '" ' +
            'style="flex-shrink:0;font-size:11px;padding:6px 12px;' +
            'background:var(--accent-color);color:#fff;border-radius:4px;' +
            'text-decoration:none;white-space:nowrap;font-weight:600">Ver</a>';
          output += '</div>';
        });

        if (output) {
          container.innerHTML = output;
        }
      })
      .catch(function () {
        // Silently fail — recommendations are optional
      });
  }

  // Carregar quando o cart drawer é aberto/atualizado
  document.addEventListener('cart:refresh', function () {
    setTimeout(loadMiniCartRecommendations, 500);
  });

  // Também tentar carregar no page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(loadMiniCartRecommendations, 1000);
    });
  } else {
    setTimeout(loadMiniCartRecommendations, 1000);
  }
})();


/* =================================================================
   Kadima — descoberta de carrosséis no mobile
   ================================================================= */
(function () {
  'use strict';

  var HINT_CLASS = 'kadima-carousel-hint';
  var MOBILE_BREAKPOINT = '(max-width: 640px)';

  function refreshCarouselHints() {
    var isMobile = window.matchMedia && window.matchMedia(MOBILE_BREAKPOINT).matches;
    document.querySelectorAll('.product-list--scrollable').forEach(function (list) {
      var host = list.closest('.scroller') || list;
      var section = host.closest('.shopify-section, section[data-section-id]') || host.parentElement;
      if (!section) return;

      var hint = section.querySelector('.'+HINT_CLASS);
      if (!hint) {
        hint = document.createElement('p');
        hint.className = HINT_CLASS;
        hint.setAttribute('role', 'status');
        hint.innerHTML = '<span aria-hidden="true">→</span> Deslize para ver mais';
        host.insertAdjacentElement('afterend', hint);
      }

      var hasAdditionalContent = list.scrollWidth > list.clientWidth + 8;
      hint.hidden = !isMobile || !hasAdditionalContent;
      hint.setAttribute('aria-hidden', String(hint.hidden));
    });
  }

  function scheduleRefresh() {
    window.requestAnimationFrame(refreshCarouselHints);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRefresh);
  } else {
    scheduleRefresh();
  }
  window.addEventListener('resize', scheduleRefresh);
  document.addEventListener('shopify:section:load', scheduleRefresh);
  window.setTimeout(scheduleRefresh, 500);
})();
